import { TasksTaskStatusEnum } from 'generated/resources/graphql'

import { TaskIdentifier } from 'modules/tasks/lib/task'

export interface TaskAnalyticsData {
  totalOverDue: number
  totalDueInfuture: number
  noDueDateTotal: number
  total: number
}

export const analyticsVariables = (currentUserId: string) => {
  return {
    assigneeId: currentUserId,
    // eslint-disable-next-line no-type-assertion/no-type-assertion
    overdue: 'over_due' as TasksTaskStatusEnum,
    // eslint-disable-next-line no-type-assertion/no-type-assertion
    noDueDate: 'no_due' as TasksTaskStatusEnum,
    // eslint-disable-next-line no-type-assertion/no-type-assertion
    dueInfuture: 'due_in_future' as TasksTaskStatusEnum,
    identifier: TaskIdentifier.Single,
  }
}
